<div class="container" style="width: 100%; max-width:300px;" ID="AddClientContainer">
  <H1>Add Client</H1>

  <div>
    <div class="form-group">
      <label>Province:</label>
      <select class="form-control" name="Province" type="text" [(ngModel)]="Province" required
        placeholder="Enter Province" (change)="ProvinceChanged()">
        <option *ngFor="let Province of Provinces; let i =index" value={{Province}}>{{Province}}
        </option>
      </select>
    </div>

    <div class="form-group" *ngIf="Province">
      <label>Area:</label>
      <select class="form-control" name="Area" type="text" [(ngModel)]="Area" required placeholder="Enter Area"
        (change)="AreaNameChanged()">
        <option *ngFor="let ar of Areas; let i =index" value={{ar}}>{{ar}}
        </option>
      </select>
    </div>

    <div class="form-group" *ngIf="Province && Area">
      <label>Client Name:</label>
      <input class="form-control" name="ClientName" type="text" [(ngModel)]="ClientName" required
        placeholder="Enter Client Name" maxlength="80" (ngModelChange)="ClientNameChanged()" />

      <label style="margin-top: 20px;">Exsisting Clients:</label>
      <select class="selectpicker form-control" multiple="true" style="padding-bottom: 0px;"
        [(ngModel)]="PossibleClient" (change)="PossibleClientChanged()">
        <option *ngFor="let item of PossibleClients; let i =index" value={{item}}>{{item}}
        </option>
      </select>
    </div>

     <div class="form-group" *ngIf="Province && Area">
      <label>Client Cell Number:</label>
      <input class="form-control" name="ClientCellNumber" type="text" [(ngModel)]="ClientCellNumber" required
        placeholder="Enter Client Cell Number" maxlength="30" />
    </div>

    <div class="form-group" *ngIf="Province && Area && ClientName && AlloCateClientPopupVersion!='true'">
      <button class="btn btn-success btn-lg btn-block" type="submit" [disabled]="!ClientName||!Province||!Area"
        (click)="AddMoreClients()">Add More Clients</button>
      <div *ngFor="let CurrNewClient of NewClientList; let i =index"  style="display: inline-flex; align-items:center; width:100%;">
        <label style=" width: 50%;">{{CurrNewClient}}</label>
        <button class="btn btn-warning btn-lg btn-block" type="submit" (click)="RemoveSpecificClient(i)" style="margin:10px; width: 50%;">Remove</button>
      </div>
    </div>


    <div class="form-group" style="display: inline-flex;">

      <div style="float: left;margin-right: 20px;">
        <button class="btn btn-primary btn-lg btn-block" type="submit" (click)="Back()"
          ID="AddClientBackBtn">Back</button>
      </div>


      <div style="float: left;margin-right: 20px;margin-left:20px;">
        <button class="btn btn-warning btn-lg btn-block" type="submit" (click)="Reset()">Reset</button>
      </div>

      <div style="float: right;margin-left:20px;">
        <button class="btn btn-success btn-lg btn-block" type="submit" [disabled]="!ClientName||!Province||!Area"
          (click)="Save()">Save</button>
      </div>

    </div>

  </div>

</div>



<div style="float: right;margin-left:20px;">
  <button class="btn btn-success btn-lg btn-block" id="ErrorButton" (click)="open(content)" style="display: none;">
  </button>
</div>
<ng-template #content let-modal ID="Errormessage">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{PopupTitle}}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">

      <span aria-hidden="true">
        ×
      </span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="dateOfBirth">
          {{DisplayErrormessage}}
        </label>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success btn-lg btn-block" (click)="modal.close('Save click')">
      Done
    </button>
  </div>
</ng-template>
